import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import appstore from "../store/appstore";

const Readmore = () => {
  const { readmoreContent } = appstore();
  const navigate = useNavigate();
  const [data, setHtml] = useState("");
  // console.log("readmoreContent", readmoreContent);
  useEffect(() => {
    if (!readmoreContent) {
      navigate("/newsletters");
      return;
    }
    (async () => {
      let config = {
        method: "get",
        maxBodyLength: Infinity,
        url: "https://api.allorigins.win/raw?url=" + readmoreContent,
        headers: {},
      };

      let data = await axios.request(config);
      setHtml(data.data);
    })();
  }, [readmoreContent]);
  return <div dangerouslySetInnerHTML={{ __html: `${data}` }}></div>;
};

export default Readmore;
